"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-width": "160px",
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Name",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      name: "name",
      required: "",
      placeholder: "Name"
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Game Level",
      prop: "gameLevel"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "Select Game Level"
    },
    model: {
      value: _vm.formData.gameLevelId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "gameLevelId", $$v);
      },
      expression: "formData.gameLevelId"
    }
  }, _vm._l(_vm.gameLevelsList, function (level) {
    return _c("el-option", {
      key: level.id,
      attrs: {
        label: level.name,
        value: level.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Reward Point",
      prop: "rewardPoint"
    }
  }, [_c("el-input-number", {
    attrs: {
      name: "rewardPoint",
      required: "",
      placeholder: "Reward Point"
    },
    model: {
      value: _vm.formData.rewardPoint,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "rewardPoint", $$v);
      },
      expression: "formData.rewardPoint"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Quantity",
      prop: "quantity"
    }
  }, [_c("el-input-number", {
    attrs: {
      name: "quantity",
      required: "",
      placeholder: "Quantity"
    },
    model: {
      value: _vm.formData.quantity,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "quantity", $$v);
      },
      expression: "formData.quantity"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Is Unlimited",
      prop: "isUnlimited"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.isUnlimited,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "isUnlimited", $$v);
      },
      expression: "formData.isUnlimited"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Description",
      prop: "description"
    }
  }, [_c("el-input", {
    attrs: {
      name: "description",
      type: "textarea",
      autosize: {
        minRows: 2,
        maxRows: 4
      },
      required: "",
      placeholder: "Description"
    },
    model: {
      value: _vm.formData.description,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "description", $$v);
      },
      expression: "formData.description"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Images",
      prop: "images"
    }
  }, [_c("file-upload", {
    attrs: {
      "file-list": _vm.images,
      accept: ".jpg, .jpeg, .png",
      multiple: ""
    },
    on: {
      change: _vm.fileUploaded,
      remove: _vm.fileRemoved
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Specification",
      prop: "specification"
    }
  }, [_c("editor", {
    attrs: {
      "api-key": "no-api-key",
      init: {
        height: 300,
        plugins: ["lists link image paste help wordcount table"],
        toolbar: "undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table"
      }
    },
    model: {
      value: _vm.formData.specification,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "specification", $$v);
      },
      expression: "formData.specification"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Priority",
      prop: "priority"
    }
  }, [_c("el-input-number", {
    attrs: {
      name: "priority",
      required: "",
      placeholder: "Priority"
    },
    model: {
      value: _vm.formData.priority,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "priority", $$v);
      },
      expression: "formData.priority"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;